module.exports = __webpack_public_path__ + "media/images/procter-and-gamble-logo-455e965639143d971042fc0dca081840.png";